const pageName = 'detailPage';

const clickEvents = {
  chooseProductSpecificationButton: {
    pageName,
    buttonName: 'chooseProductSpecification'
  },
  viewProductSpecificationButton: {
    pageName,
    buttonName: 'viewProductSpecification'
  },
  addToCartButton: {
    pageName,
    buttonName: 'addToCart'
  },
  buyNowButton: {
    pageName,
    buttonName: 'buyNow'
  },
  searchProductButton: {
    pageName,
    buttonName: 'searchProduct'
  },
  shipmentLegalpolicyButton: {
    pageName,
    buttonName: 'showShipmentLegalpolicy'
  },
  allReviewButton: {
    pageName,
    buttonName: 'showAllReviews'
  },
  toHomeButton: {
    pageName,
    buttonName: 'returnToHome'
  },
  toCartButton: {
    pageName,
    buttonName: 'goToCart'
  },
  visitBrandStoreButton: {
    pageName,
    buttonName: 'visitBrandStore'
  },
  claimCouponButton: {
    pageName,
    buttonName: 'claimCoupon'
  },
  shareProductButton: {
    pageName,
    buttonName: 'shareProduct'
  },
  addToFavoriteButton: {
    pageName,
    buttonName: 'addToFavorite'
  }
};

const loadingEvents = {
  detailPage: {
    pageName,
    eventName: 'ATF'
  }
};

export default {
  clickEvents,
  loadingEvents
};
